import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgHealthgrades = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "2 4 20 16.36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M16.6085 10.2215C16.7979 10.4102 17.0541 10.5165 17.3214 10.5174C17.5823 10.5174 17.8258 10.4129 18.0347 10.2215L21.6171 6.63889C21.9996 6.2564 21.9996 5.61304 21.6171 5.23054C21.2344 4.84782 20.591 4.84782 20.2083 5.23054L16.6257 8.81293C16.2124 9.18856 16.2045 9.83592 16.6085 10.2215Z",
			fill: "#0202EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M19.8433 11.9259C19.4608 11.5434 18.8694 11.5434 18.4693 11.8912L13.3217 17.039C13.0261 17.3346 12.5565 17.3346 12.2782 17.039C11.9826 16.7434 11.9826 16.2738 12.2782 15.9955L14.1217 14.1521V14.1347L16.0346 12.2216C16.4173 11.8391 16.4173 11.1955 16.0346 10.813C15.6521 10.4302 15.0085 10.4302 14.626 10.813L13.5131 11.9259L13.3391 12.0997C13.0435 12.3955 12.5915 12.3955 12.2956 12.0997C12 11.8043 12 11.3521 12.2956 11.0565L13.0608 10.2912L16.7477 6.60437C17.1304 6.22164 17.1304 5.57828 16.7477 5.19556C16.3652 4.81306 15.7216 4.81306 15.3391 5.19556L13.1306 7.35198C12.939 7.54335 12.6781 7.64783 12.4349 7.64783C12.1841 7.64845 11.9422 7.55541 11.7565 7.38696L9.68696 5.31742C7.9304 3.56086 5.07826 3.56086 3.32193 5.31742C2.46937 6.16929 2 7.29986 2 8.49993C2 9.69978 2.4696 10.8303 3.3217 11.6824L11.6696 20.0301C11.6696 20.0475 11.687 20.0475 11.687 20.0649C11.8764 20.2536 12.1326 20.3599 12.3999 20.3607C12.6607 20.3607 12.9042 20.2563 13.1132 20.0649L19.826 13.3521C20.2221 12.962 20.2299 12.3256 19.8433 11.9259Z",
			fill: "#0202EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0089 11.5087C21.5564 11.5087 22.0002 11.0649 22.0002 10.5174C22.0002 9.96985 21.5564 9.52602 21.0089 9.52602C20.4614 9.52602 20.0176 9.96985 20.0176 10.5174C20.0176 11.0649 20.4614 11.5087 21.0089 11.5087Z",
			fill: "#0202EA"
		})
	]
});
const ForwardRef = forwardRef(SvgHealthgrades);
export { ForwardRef as ReactComponent };
